module.exports = __webpack_public_path__ + "assets/media/d-3.1126da22.svg";